import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { changePasswordDto } from 'src/app/tabms/models/base/base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private baseUrl = environment.apiUrl + 'account/my-profile';

  constructor(private http: HttpClient) {}

  changePassword(data: changePasswordDto): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/change-password`, data);
  }
 
}
